module.exports = __webpack_public_path__ + "static/media/YB5F12_3.2e42e076.jpg";